/* eslint-disable multiline-ternary */
import React, { ReactElement, ReactNode } from 'react'
import { useFormContext } from 'react-hook-form'
import TextInputSkeleton from './TextInputSkeleton'
import 'react-tooltip/dist/react-tooltip.css'
import { getInputOptions } from '../../util/inputOptionsHelper'
import InputOptionType from '../../enums/InputOptionType'
import SmallText from '../text/SmallText'

interface Props {
  variable: string
  optionType?: InputOptionType
  title: string
  className?: string
  loading?: boolean
  disabled?: boolean
  unit?: string
  hideTitle?: boolean
  hidePlaceholder?: boolean
  hideError?: boolean
}

const TextArea: React.FC<Props> = ({
  variable,
  optionType,
  title,
  className = '',
  disabled = false,
  loading = false,
  unit,
  hideTitle = false,
  hidePlaceholder = false,
  hideError = false
}: Props): ReactElement => {
  const {
    register,
    clearErrors,
    formState: { errors }
  } = useFormContext()

  let error: any = errors
  variable.split('.').forEach((v) => {
    if (error && error[v]) {
      error = error[v]
    } else {
      error = null
    }
  })

  const options = getInputOptions(optionType)

  const loadingStyle = loading ? { marginTop: '-3px' } : {}

  return (
    <div className="relative" style={loadingStyle}>
      {!loading && (
        <div className="relative overflow-hidden">
          {!hideTitle && (
            <SmallText style="secondary" className="mb-1">
              {title}
            </SmallText>
          )}
          <textarea
            className={`border rounded-md bg-backgroundLight dark:bg-stone-950 dark:border-stone-950 overflow-hidden flex px-2.5 py-1.5 ${
              disabled ? 'opacity-80' : ''
            } focus:border-primary outline-0 h-20 ${
              error != null ? 'border-error focus:border-error' : ''
            } ${className}`}
            disabled={disabled}
            {...register(variable, options)}
            placeholder={!hidePlaceholder ? title : undefined}
            autoComplete="none"
            onChange={() => clearErrors(variable)}
          />
          {unit && (
            <div className=" absolute right-0 top-0 h-full w-8 bg-gray-200 rounded-r-md flex justify-center items-center font-semibold text-black">
              {unit}
            </div>
          )}
        </div>
      )}
      {loading && <TextInputSkeleton />}
      {!hideError && error != null && error?.type !== 'required' ? (
        <div className="text-error">{error?.message as ReactNode}</div>
      ) : (
        <div className="h-3"></div>
      )}
    </div>
  )
}

export default TextArea
